import React from 'react';
import { Check, FileText, Package } from 'lucide-react';
import { Section } from './Shared';
export const MethodOverview = () => {
  const tomos = [{
    color: 'bg-[#FFF5F5] border-brand-pink/30',
    icon: '📘',
    title: 'TOMO PRINCIPAL — REFLEXO-PRO',
    subtitle: 'Sistema de Gestión Clínica Profesional · 50 páginas',
    desc: 'El manual completo para organizar, estructurar y profesionalizar tu trabajo como terapeuta en reflexología.',
    bullets: ['Parte 1: Tu gabinete como espacio profesional', 'Parte 2: El sistema de registro clínico completo', 'Parte 3: El método de seguimiento de terapias', 'Parte 4: La estructura de la sesión profesional', 'Parte 5: El compromiso con el paciente', 'Parte 6: Tu gabinete como negocio'],
    materials: '✅ 100% orientado al terapeuta argentino'
  }];
  const checklist = ['Sistema completo de gestión clínica', '110 páginas — Todo resuelto', '100% orientado al terapeuta argentino', 'Listo para imprimir y usar desde el primer día'];
  return <Section id="method" data-id="element-167">
      <div className="text-center mb-16" data-id="element-168">
        <div className="inline-flex items-center space-x-2 bg-white border border-brand-rose/30 px-4 py-1.5 rounded-full mb-6 shadow-sm" data-id="element-169">
          <span className="text-xl" data-id="element-170">🏆</span>
          <span className="font-serif font-semibold tracking-wider text-brand-rose text-sm md:text-base" data-id="element-171">
            KIT REFLEXO-PRO™
          </span>
        </div>
        <h2 className="md:text-5xl font-serif font-bold mb-4 text-[28px]" data-id="element-172">
          Tomo Principal + 2 Bonus
        </h2>
        <p className="text-brand-muted mb-2 text-[16px]" data-id="element-173">
          Sistema completo de gestión clínica · 110 páginas — Todo resuelto.
        </p>
      </div>

      <h3 className="font-serif font-bold text-center rose-gradient-text text-[22px] mt-[10px] mb-[10px] ml-[10px] mr-[10px]" data-id="element-174">
        EL SISTEMA COMPLETO
      </h3>

      <div className="space-y-6 mb-16 max-w-4xl mx-auto" data-id="element-175">
        {tomos.map((tomo, i) => <div key={i} className={`rounded-2xl p-6 md:p-8 border ${tomo.color} backdrop-blur-sm bg-white/60 shadow-sm`} data-id="element-176">
            <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-177">
              <div className="text-4xl shrink-0" data-id="element-178">{tomo.icon}</div>
              <div className="flex-grow" data-id="element-179">
                <h4 className="font-serif font-bold mb-2 text-lg text-brand-rose" data-id="element-180">
                  {tomo.title}
                </h4>
                <p className="text-brand-text/90 font-medium mb-2 text-base" data-id="element-181">
                  {tomo.subtitle}
                </p>
                <p className="text-brand-text/80 text-sm mb-4" data-id="element-182">{tomo.desc}</p>
                <ul className="space-y-2 mb-4" data-id="element-183">
                  {tomo.bullets.map((bullet, j) => <li key={j} className="flex items-start text-brand-text/80 text-[12px]" data-id="element-184">
                      <span className="text-brand-rose mr-2 mt-0.5" data-id="element-185">→</span>
                      {bullet}
                    </li>)}
                </ul>
                <div className="bg-white/50 p-3 rounded-lg border border-brand-pink/20 text-xs text-brand-text/70 flex items-center" data-id="element-186">
                  {tomo.materials}
                </div>
              </div>
            </div>
          </div>)}
      </div>

      <div className="glass-panel rounded-3xl p-8 md:p-12 max-w-3xl mx-auto mb-[90px] bg-white/80 border-brand-pink/30" data-id="element-187">
        <h4 className="text-xl font-serif font-bold mb-6 text-center" data-id="element-188">
          Todo el sistema incluye:
        </h4>
        <ul className="space-y-4" data-id="element-189">
          {checklist.map((item, i) => <li key={i} className="flex items-start" data-id="element-190">
              <Check className="w-5 h-5 text-brand-green mr-3 mt-0.5 shrink-0" data-id="element-191" />
              <span className="text-brand-text/90 text-[14px]" data-id="element-192">{item}</span>
            </li>)}
        </ul>
      </div>

      <div className="text-center mb-12" data-id="element-193">
        <h3 className="md:text-4xl font-serif font-bold mb-4 text-[24px]" data-id="element-194">
          🎁 2 BONUS INCLUIDOS
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-195">
        <div className="glass-panel rounded-2xl p-6 border-brand-rose/30 relative overflow-hidden bg-white/80" data-id="element-196">
          <div className="absolute top-0 right-0 bg-brand-rose text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-197">
            GRATIS
          </div>
          <FileText className="w-8 h-8 text-brand-rose mb-3" data-id="element-198" />
          <h4 className="text-xl font-serif font-bold mb-2" data-id="element-199">
            BONUS 1 — EL LEGAJO DE CAMPO
          </h4>
          <p className="text-brand-rose/90 text-sm font-medium mb-2" data-id="element-200">
            Planillas profesionales para registrar cada sesión · 30 páginas
          </p>
          <p className="text-brand-text/80 mb-4 text-[12px]" data-id="element-201">
            Para que nunca más le preguntes a un paciente cómo se sentía la vez
            anterior.
          </p>
          <ul className="space-y-2 mb-4 text-brand-text/80 text-[12px]" data-id="element-202">
            <li data-id="element-203">→ Ficha de anamnesis y antecedentes clínicos</li>
            <li data-id="element-204">→ Consentimiento informado</li>
            <li data-id="element-205">→ Registro de sesión y evolución del paciente</li>
            <li data-id="element-206">→ Planilla de zonas trabajadas y reacciones post-sesión</li>
            <li data-id="element-207">→ Hoja de indicaciones para entregar al paciente</li>
            <li data-id="element-208">→ Planilla de alta terapéutica con firma</li>
          </ul>
          <div className="text-xs font-medium text-brand-green mt-auto" data-id="element-209">
            ✅ 18 planillas listas para imprimir
            <br data-id="element-210" />✅ Tu legajo clínico completo desde el primer día
          </div>
        </div>

        <div className="glass-panel rounded-2xl p-6 border-brand-rose/30 relative overflow-hidden bg-white/80" data-id="element-211">
          <div className="absolute top-0 right-0 bg-brand-rose text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-212">
            GRATIS
          </div>
          <Package className="w-8 h-8 text-brand-rose mb-3" data-id="element-213" />
          <h4 className="text-xl font-serif font-bold mb-2" data-id="element-214">
            BONUS 2 — EL CONTROL DE ABASTECIMIENTO
          </h4>
          <p className="text-brand-rose/90 text-sm font-medium mb-2" data-id="element-215">
            Planillas de stock y organización del gabinete · 30 páginas
          </p>
          <p className="text-brand-text/80 mb-4 text-[12px]" data-id="element-216">
            Para que tu gabinete nunca te quede a mitad de camino. Controlás.
            Reponés. Trabajás sin interrupciones.
          </p>
          <ul className="space-y-2 mb-4 text-brand-text/80 text-[12px]" data-id="element-217">
            <li data-id="element-218">→ Auditoría inicial del gabinete</li>
            <li data-id="element-219">→ Lista maestra de insumos esenciales</li>
            <li data-id="element-220">
              → Sistema Verde, Amarillo y Rojo — actuás antes del faltante
            </li>
            <li data-id="element-221">→ Control semanal de stock en 10 minutos</li>
            <li data-id="element-222">→ Checklists de apertura y cierre para plastificar</li>
            <li data-id="element-223">→ Registro de proveedores y vencimientos</li>
            <li data-id="element-224">→ Resumen mensual de gastos e insumos</li>
          </ul>
          <div className="text-xs font-medium text-brand-green mt-auto" data-id="element-225">
            ✅ 20 planillas listas para imprimir y usar
            <br data-id="element-226" />✅ Nunca más te falta nada en plena jornada
          </div>
        </div>
      </div>
    </Section>;
};